export default function PageFooter() {
  return (
    <footer className="text-center text-secondary py-3">
      Copyright © Fish Window Cleaning. All rights reserved.
    </footer>
  );
}
